module.exports = __webpack_public_path__ + "img/logo.db80c016.jpeg";